import ViewBase from "../../../../framework/core/mvvm/view_base";
import { ListView, ListViewDir } from "../../../../framework/tools/scrollview/listview";
import FirendBaseItem from "./component/friend_base_item";
import { friend_utils } from "./friend_utils";
import FriendSearchItem from "./component/friend_search_item";

import FriendListItem from "./component/friend_list_item";
import Utility from "../../../../utility/utility";
import ModuleManager from "../../../../framework/core/module_manager";
import FriendTransferModule from "./friend_transfer_module";

const {ccclass, property} = cc._decorator;

enum page_type{
    list = 0,
    invite,
}

@ccclass
export default class FriendView extends ViewBase {

    @property(cc.ScrollView)
    scrollViewList : cc.ScrollView = null;

    @property(cc.ScrollView)
    scrollViewInvite : cc.ScrollView = null;

    @property(cc.Node)
    listContent : cc.Node = null;

    @property(cc.Node)
    inviteContent : cc.Node = null;

    @property(cc.Node)
    viewList : cc.Node = null;

    @property(cc.Node)
    viewInivte : cc.Node = null;

    @property([cc.Node])
    itemPrefabs : cc.Node[] = [];

    @property(cc.EditBox)
    serachEditBox : cc.EditBox = null;

    @property([cc.Toggle])
    toggleList : cc.Toggle[] = [];

    @property([cc.Node])
    pageNodes : cc.Node[] = [];

    @property(cc.Node)
    inviteBg : cc.Node = null;

    @property(FriendSearchItem)
    searchItem : FriendSearchItem = null;

    @property(cc.Node)
    noFriendTips : cc.Node = null;

    private listView : ListView = null;
    private inviteListView : ListView = null;

    private curType : page_type = page_type.list;

    public friendList : any[] = []; //好友列表

    public inviteList : any[] = []; //申请列表

    private transferRemain : number;

    private currency : number;

    onLoad(){

        this.serachEditBox.node.on('text-changed', this.onSerach, this);
        this.eventBind("friend_transfer_remain",this.on_friend_transfer_remain);
        this.eventBind("friend_remove_friend",this.on_friend_update);
        this.eventBind("friend_add_friend",this.on_friend_update);
        this.eventBind("request_transfer_friend",this.on_request_transfer_friend);

    }
    private on_request_transfer_friend(index : number){
        
        let data = this.friendList[index];

        ModuleManager.instance.showModule(FriendTransferModule,
            {currency:this.currency,
            transferRemain:this.transferRemain,
            friendData : data});

        //this.transCom.show(this.currency,this.transferRemain,data);

    }
    

    private on_friend_transfer_remain(remain : number){

        this.transferRemain = remain;

        this.updateFriendItem("remain")
    }

    private on_friend_update(friendId : number){

        if (this.curType == page_type.list) {
            
            this.friendList = friend_utils.friendList;
            this.updateListView();
        }        
    }


    private onSerach(){

        if(!this.serachEditBox.string.match("^[0-9]*$")){
            this.serachEditBox.string = this.serachEditBox.string.substring(0, this.serachEditBox.string.length - 1);
            this.serachEditBox.blur();
        }
    }

    public refreshFriendList(){

        this.curType = page_type.list;

        this.pageNodes[page_type.list].active = true;
        this.pageNodes[page_type.invite].active = false;

        this.requestList();
        
    }

    public refreshInvite(){

        this.curType = page_type.invite;

        this.pageNodes[page_type.list].active = false;
        this.pageNodes[page_type.invite].active = true;

        //this.searchItem.node.active = false;

        this.requestInvite();

    }

    

    public onToggleList(){

        Utility.playButtonSound();

        this.refreshFriendList();
    }


    public onToggleInvite(){

        Utility.playButtonSound();

        this.refreshInvite();
    }

    public updateListView( ){

        let listView;
        
        let dataList : any[] = [];

        if (this.curType == page_type.list) {
            dataList = this.friendList;  
            listView = this.listView;
            
        }else if(this.curType == page_type.invite){
            dataList = this.inviteList;     
            listView = this.inviteListView;
            this.inviteBg.active = true;
        }

        if (!listView) {
         
            listView = new ListView({
                scrollview: this.curType == page_type.list ? this.scrollViewList : this.scrollViewInvite,
                view: this.curType == page_type.list ? this.viewList : this.viewInivte,
                content: this.curType == page_type.list ? this.listContent : this.inviteContent,
                item_prefab:  this.itemPrefabs[this.curType],
                cb_host: this,
                item_update_func: this.itemUpdate,
                select_cb: null,
                column: 1,
                row: 1,
                gap_y: 10,
                direction: ListViewDir.Vertical,
            });
        }        
       
        listView.set_data(dataList);
        listView.scroll_to(0);   

        if (this.curType == page_type.list) {
            this.listView = listView;
        }else if(this.curType == page_type.invite){
            this.inviteListView = listView;
        }

    }



    public updateCurrency(currency : number){
        this.currency = currency;
        //这里更新好友列表信息
        this.updateFriendItem("currency")
    }

    private updateFriendItem(type : string){

        if (this.curType == page_type.list && this.listView && this.listView.items) {
            this.listView.items.forEach((item)=>{
                if (item.node && item.node.isValid) {
                    let listItem = item.node.getComponent(FriendListItem);
                    if (null != listItem) {  
                        if (type == "currency") {
                            listItem.updateCurrency(this.currency);
                        }else if(type == "remain"){
                            listItem.updateRemain(this.transferRemain);
                        }
                    }
                }
            });
        }        
    }

    public itemUpdate(item : cc.Node,data:any,index :number){

        let baseItem = item.getComponent(FirendBaseItem);

        baseItem.index = index;
        baseItem.updateInfo(data,this.currency);

        this.inviteBg.active = false;

        let listItem = item.getComponent(FriendListItem);
        if (null != listItem) {            
            listItem.updateRemain(this.transferRemain);
        }
    }

    public onShow(arg : any){
        super.onShow(arg);    
        
        if (this.toggleList.length > 0) {
            
            this.toggleList[0].check();
        }
        this.refreshFriendList();

        let self = this;
        friend_utils.getTodayRemain((remain)=>{
            self.transferRemain = remain;
            self.updateFriendItem("remain")
        });
    }
 
    public requestList(){        

        let self = this;
        friend_utils.reqFriendList(this,(friendList : any[])=>{

            if (self.curType == page_type.list) {

                self.friendList = friendList;
                self.updateListView();                        
            }
            self.noFriendTips.active = !friendList || friendList.length ==0;

        });


    }

    public requestInvite(){
     
        let self = this;
        friend_utils.reqInviteList(this,(list:any)=>{

            if (self.curType == page_type.invite) {
                self.inviteList = list;
                self.updateListView();
            }
        })
    }


}